import { CreditCard, Nfc, RectangleEllipsis } from 'lucide-react'
import type { EntryMode } from '../types'

const CONFIG: Record<EntryMode, { Icon: React.ComponentType<{ size?: number }>; label: string }> = {
  chip: { Icon: CreditCard, label: 'Chip' },
  contactless: { Icon: Nfc, label: 'Contactless' },
  magstripe: { Icon: RectangleEllipsis, label: 'Magstripe' },
}

/**
 * AF-125 — entry mode icon for POS transactions only.
 * Magstripe entries on supposedly-chip cards is a classic skimming signal.
 */
export function EntryModeIcon({ mode }: { mode: EntryMode }) {
  const { Icon, label } = CONFIG[mode]
  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-fg" aria-label={`Entry mode: ${label}`}>
      <Icon size={14} />
      {label}
    </span>
  )
}
